import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";

import KogInputAutoCompleteCheckControlled from "@/main/components/shared/inputAutoCompleteCheck/inputAutoCompleteCheckControlled";
import { isNullUndefined } from "@/main/services/utils";
import { getModels, resetReducerModels, useModelReducer } from "@/main/store/vehicle/model";
import { GeneralVariableType, useDynamicFiltersExport } from "./dynamicFiltersExport";

interface IVariableTypeModelProps extends GeneralVariableType {}
function VariableTypeModel({ filter }: IVariableTypeModelProps) {
	const dispatch = useDispatch();
	const { keyReducer, findFieldIndexByGuidDynamicReportVariable, idScreen, watcherCountry } = useDynamicFiltersExport();
	const { isolated: modelsReducer } = useModelReducer(keyReducer);
	const { control } = useFormContext();

	useEffect(() => {
		if (isNullUndefined(watcherCountry)) return;

		dispatch(getModels({ guidManufacturer: String("") }, keyReducer));

		return () => {
			dispatch(resetReducerModels(keyReducer));
		};
	}, [JSON.stringify(watcherCountry?.key)]);

	const disabledModel = isNullUndefined(modelsReducer.data) || modelsReducer.data.length === 1;
	const indexField = findFieldIndexByGuidDynamicReportVariable(filter.guidDynamicReportVariable);

	return (
		<>
			<KogInputAutoCompleteCheckControlled
				name={`filtersDinamics.${indexField}.value`}
				disableSelectAll
				control={control}
				options={modelsReducer.data || []}
				label={filter.responseServer.filterName}
				disabled={disabledModel}
				isLoading={modelsReducer.isLoading}
				controllerProps={{
					rules: { required: filter.responseServer.mandatory },
				}}
				customInputProps={{
					required: filter.responseServer.mandatory,
					id: idScreen("select-model"),
				}}
				onChangeCustom={() => {}}
			/>
		</>
	);
}

export default VariableTypeModel;
